import React, { useEffect, useRef, useState } from 'react';
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { allDoctorSearchDetail, allProblemSearchDetail, leadCreate, patientSearchData, searchAllCounselorDetail, updateLead } from '../../../redux/actions/Files.action';
import { getBranch, getCounselor, getDoctor, getProblem, searchCounselor, searchDoctor } from '../../../redux/actions/Master.action';
import userPhoto from '../../../assets/img/user.png'
import { useLocation } from 'react-router-dom';
import { ErrorMessage } from 'formik';
import { getSetting } from '../../../redux/actions/Setting.action';

const FileUpdate = ({ updateModal, updateToggle, updateId, searchDefault1 }) => {

  const [mainPage, setMainPage] = useState(1)
  const dispatch = useDispatch();
  const dropdownRef = useRef(null)
  const location = useLocation()
  const createFile = useSelector((state) => state.files);
  const masterData = useSelector((state) => state.master)

  const [doctorData, setDoctorData] = useState(false)
  const [doctorData1, setDoctorData1] = useState(false)
  const [doctorData2, setDoctorData2] = useState(false)
  const [problemData, setProblemData] = useState(false);

  const [selectedCampaign, setSelectedCampaign] = useState('');
  const [selectedReference, setSelectedReference] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [selectedCounselor, setSelectedCounselor] = useState('');
  const [selectedProblem, setSelectedProblem] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [showAll, setShowAll] = useState(false);
  const toggleShow = () => { setShowAll(!showAll); };
  const [searchType, setSearchType] = useState('doctor');
  const [searchQuery, setSearchQuery] = useState("");
  const [searchDefault, setSearchDefault] = useState({
    page: "",
    search: "",
  });
  const setting = useSelector((state) => state.setting);
  console.log(setting)

  const [values, setValues] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    nationality: "",
    country: "",
    state: "",
    city: "",
    area: "",
    address: "",
    pincode: "",
    phoneNumber: "",
    email: "",
    occupation: "",
    bloodGroup: "",
    photo: null,
    branch: "",
    leadReceived: "",
    problem: '',
    leadStatus: "",
    leadFrom: "",
    campaign: [
      { cname: '', description: '' }
    ],
    reference: [
      { personDetail: '', doctorDetail: '' }
    ],
    remark: "",
    nextFollowUpDate: "",
    from: "",
    to: "",
    doctorName: "",
    counselorAssign: "",
    leadFollowUpRemark: "",
  })

  // useEffect(() => {
  //   if (updateId) {
  //     setValues({
  //       patientId: updateId?._id || "",
  //       firstName: updateId?.firstName || "",
  //       middleName: updateId?.middleName || "",
  //       lastName: updateId?.lastName || "",
  //       gender: updateId?.gender || "",
  //       dateOfBirth: updateId?.dateOfBirth
  //         ? new Date(updateId?.dateOfBirth).toISOString().substring(0, 10)
  //         : "",
  //       nationality: updateId?.nationality || "",
  //       country: updateId?.country || "",
  //       state: updateId?.state || "",
  //       city: updateId?.city || "",
  //       area: updateId?.area || "",
  //       address: updateId?.address || "",
  //       pincode: updateId?.pincode || "",
  //       phoneNumber: updateId?.phoneNumber || "",
  //       email: updateId?.email || "",
  //       occupation: updateId?.occupation || "",
  //       bloodGroup: updateId?.bloodGroup || "",
  //       photo: updateId?.photo || values.photo,
  //       branch: updateId?.branch || "",
  //       leadReceived: updateId?.leadReceived || "",
  //       problem: updateId?.problem || '',
  //       leadStatus: updateId?.leadStatus || "",
  //       campaign: [
  //         { cname: updateId?.campaign[0]?.cname || '', description: updateId?.campaign[0]?.description || '' }
  //       ],
  //       reference: [
  //         { personDetail: updateId?.reference[0]?.personDetail || '', doctorDetail: updateId?.reference[0]?.doctorDetail || '' }
  //       ],
  //       remark: updateId?.remark || "",
  //       nextFollowUpDate: updateId?.nextFollowUpDate
  //         ? new Date(updateId?.nextFollowUpDate).toISOString().substring(0, 10)
  //         : "",
  //       from: updateId?.from
  //         ? new Date(updateId.from).toISOString().substring(11, 16)
  //         : "",

  //       to: updateId?.to
  //         ? new Date(updateId.to).toISOString().substring(11, 16)
  //         : "",
  //       doctorName: updateId?.doctorName || "",
  //       counselorAssign: updateId?.counselorAssign || "",
  //       leadFollowUpRemark: updateId?.leadFollowUpRemark || "",
  //     })
  //     if (updateId.reference[0]?.personDetail != '') {
  //       setSelectedReference('Person');
  //       setSelectedOption(updateId.reference[0]?.personDetail)
  //     } else {
  //       setSelectedReference('Doctor');
  //       setSelectedOption(updateId.reference[0]?.doctorDetail)
  //     }
  //   }
  // }, [updateId])
  const [leadStatuses, setLeadStatuses] = useState([]);

  // Add this useEffect to fetch lead statuses
    useEffect(() => {
      if (
        setting?.getSetting?.getSetting?.leadStatuses &&
        setting?.getSetting?.getSetting?.leadStatuses?.length > 0
      ) {
        setLeadStatuses(setting?.getSetting?.getSetting?.leadStatuses || []);
      }
    }, [setting]);

  // Add the getBackgroundColor function
  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(
      (status) => status.title.toLowerCase() === leadStatusName.toLowerCase(),
    );
    return status ? status.backgroundColor : 'transparent';
  };

  useEffect(() => {
    dispatch(getSetting())
  }, [])

  useEffect(() => {
    if (updateId) {
      setValues((prev) => (
        {
          ...prev,
          patientId: updateId?._id || "",
          firstName: updateId?.firstName || "",
          middleName: updateId?.middleName || "",
          lastName: updateId?.lastName || "",
          gender: updateId?.gender || "",
          dateOfBirth: updateId?.dateOfBirth
            ? new Date(updateId?.dateOfBirth).toISOString().substring(0, 10)
            : "",
          nationality: updateId?.nationality || "",
          country: updateId?.country || "",
          state: updateId?.state || "",
          city: updateId?.city || "",
          area: updateId?.area || "",
          address: updateId?.address || "",
          pincode: updateId?.pincode || "",
          phoneNumber: updateId?.phoneNumber || "",
          email: updateId?.email || "",
          occupation: updateId?.occupation || "",
          bloodGroup: updateId?.bloodGroup || "",
          photo: updateId?.photo || prev.photo, // Only update photo if provided
          branch: updateId?.branch || "",
          leadReceived: updateId?.leadReceived || "",
          problem: updateId?.problem || '',
          leadStatus: updateId?.leadStatus || "",
          leadFrom: updateId?.leadFrom || "",
          campaign: [
            { cname: updateId?.campaign[0]?.cname || '', description: updateId?.campaign[0]?.description || '' }
          ],
          reference: [
            { personDetail: updateId?.reference[0]?.personDetail || '', doctorDetail: updateId?.reference[0]?.doctorDetail || '' }
          ],
          remark: updateId?.remark || "",
          nextFollowUpDate: updateId?.nextFollowUpDate
            ? new Date(updateId?.nextFollowUpDate).toISOString().substring(0, 10)
            : "",
          from: updateId?.from
            ? new Date(updateId.from).toISOString().substring(11, 16)
            : "",
          to: updateId?.to
            ? new Date(updateId.to).toISOString().substring(11, 16)
            : "",
          doctorName: updateId?.doctorName || "",
          counselorAssign: updateId?.counselorAssign || "",
          leadFollowUpRemark: updateId?.leadFollowUpRemark || "",
        }));

      if (updateId.reference[0]?.personDetail !== '') {
        setSelectedReference('Person');
        setSelectedOption(updateId.reference[0]?.personDetail);
      } else {
        setSelectedReference('Doctor');
        setSelectedOption(updateId.reference[0]?.doctorDetail);
      }
    }
  }, [updateId]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValues((prevValues) => ({
        ...prevValues,
        photo: file,
      }));
    }
  };

  const handleLead = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const limits = {
    page: mainPage,
    limit: 10
  }

  const handleCampaignChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cname') {
      setSelectedCampaign(value);
      setValues((prevValues) => ({
        ...prevValues,
        campaign: [{ cname: value, description: prevValues.campaign[0].description }]
      }));
    } else if (name === 'description') {
      setValues((prevValues) => ({
        ...prevValues,
        campaign: [{ cname: prevValues.campaign[0].cname, description: value }]
      }));
    }
  };

  const handleReferenceChange = (e) => {
    const { value } = e.target;
    setSelectedReference(value);
    setSelectedOption('');
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setDoctorData(false);

    if (selectedReference === 'Person') {
      setValues((prevValues) => ({
        ...prevValues,
        reference: [
          { personDetail: option, doctorDetail: "" }, // Clear doctorDetail when Person is selected
        ],
      }));
    } else if (selectedReference === 'Doctor') {
      setValues((prevValues) => ({
        ...prevValues,
        reference: [
          { personDetail: "", doctorDetail: option }, // Clear personDetail when Doctor is selected
        ],
      }));
    }
  };

  const selectDoctor = (doctorName) => {
    setSelectedDoctor(doctorName);
    setDoctorData1(false);
    setSearchQuery('')
    setSearchDefault({ page: '', search: '' });
    dispatch(allDoctorSearchDetail('', '1'));

    setValues(prevValues => ({
      ...prevValues,
      doctorName: doctorName
    }));
  };

  const selectCounselor = (counselorName) => {
    setSelectedCounselor(counselorName)
    setDoctorData2(false);
    setSearchQuery('')
    setSearchDefault({ page: '', search: '' });
    dispatch(searchAllCounselorDetail({ search: '' }))
    setValues(prevValues => ({
      ...prevValues,
      counselorAssign: counselorName
    }));
  }

  const selectProblem = (problemName) => {
    setSelectedProblem(problemName);
    setProblemData(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(allProblemSearchDetail('', '1'));
    setValues((prevValues) => ({
      ...prevValues,
      problem: problemName,
    }));
  };

  // const convertToFormData = (values) => {
  //   const formData = new FormData();

  //   Object.keys(values).forEach(key => {
  //     if (Array.isArray(values[key])) {
  //       formData.append(key, JSON.stringify(values[key]));
  //     } else if (values[key] instanceof File) {
  //       formData.append(key, values[key]);
  //     } else {
  //       formData.append(key, values[key]);
  //     }
  //   });

  //   return formData;
  // };

  const convertToFormData = (values) => {
    const formData = new FormData();

    Object.keys(values).forEach(key => {
      // Check if the key is 'photo' and whether it should be included in the payload
      if (key === 'photo' && typeof values[key] === 'string') {
        // If the photo is a string (URL of the existing photo), do not add it to FormData
        return;
      }
      if (Array.isArray(values[key])) {
        formData.append(key, JSON.stringify(values[key]));
      } else if (values[key] instanceof File) {
        formData.append(key, values[key]);
      } else {
        formData.append(key, values[key]);
      }
    });

    return formData;
  };

  const handleUpdate = () => {
    const formData = convertToFormData(values);
    formData.forEach((value, key) => {
      console.log(key, value);
    });
    let queryParams;

    if (location.pathname === '/master/allfollowup') {
      queryParams = {
        page: mainPage,
        limit: 10,
      };
    } else {
      queryParams = {
        page: mainPage,
        limit: 10,
        date: selectedDate,
        status: values.leadStatus, // Add the status to query params
      };
    }
    dispatch(updateLead(formData, limits, searchDefault1.status, queryParams)).then(() => {
      updateToggle()
      setValues({
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        dateOfBirth: "",
        nationality: "",
        country: "",
        state: "",
        city: "",
        area: "",
        address: "",
        pincode: "",
        phoneNumber: "",
        email: "",
        occupation: "",
        bloodGroup: "",
        photo: null,
        branch: "",
        leadReceived: "",
        leadFrom: "",
        problem: '',
        leadStatus: "",
        campaign: [
          { cname: '', description: '' }
        ],
        reference: [
          { personDetail: '', doctorDetail: '' }
        ],
        remark: "",
        nextFollowUpDate: "",
        from: "",
        to: "",
        doctorName: "",
        counselorAssign: "",
        leadFollowUpRemark: "",
      })
    })
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelectedReference(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const searchData = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || "",
      page: "1"
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    if (searchType === 'doctor') {
      dispatch(allDoctorSearchDetail(searchQuery))
    } else if (searchType === 'counselor') {
      dispatch(searchAllCounselorDetail(newSearchParams));
    }
    else if (searchType === 'problem') {
      dispatch(allProblemSearchDetail(searchQuery))
    }

    if (searchType === 'Doctor') {
      dispatch(allDoctorSearchDetail(searchQuery));
    } else if (searchType === 'Person') {
      dispatch(patientSearchData(searchQuery));
    }
    // dispatch(searchCounselor(queryParams, newSearchParams.page))
    // dispatch(allDoctorSearchDetail(newSearchQuery))
    // dispatch(allProblemSearchDetail(newSearchQuery))
  }

  useEffect(() => {
    dispatch(getDoctor(limits))
    dispatch(getCounselor(limits))
  }, [])

  // const formatDate = (dateStr) => {
  //   const date = new Date(dateStr);
  //   return date.toLocaleDateString();
  // };
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatTime = (timeStr) => {
    const date = new Date(timeStr);
    return timeStr ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }) : '';
  };

  const updateHistory = createFile?.viewLead?.data?.PatientData?.updateHistory || [];
  const sortedUpdateHistory = [...updateHistory].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  );
  const displayedRecords = showAll ? sortedUpdateHistory : sortedUpdateHistory.slice(0, 3);

  return (
    <Modal show={updateModal} onHide={updateToggle} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Update Lead</Modal.Title>
      </Modal.Header>

      <Form>
        <Modal.Body>
          <div className="row">
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Branch</Form.Label>
                <Form.Select
                  placeholder="Select Branch"
                  className="shadow-none focus:!border-theme-dark"
                  name="branch"
                  value={values.branch}
                  onChange={handleLead}
                >
                  <option value="" disabled selected>
                    Select Branch
                  </option>{' '}
                  {
                    createFile?.allBranch?.data?.Branches?.map((res) => {
                      return (
                        <option key={res._id} value={res.branchName}>{res.branchName}</option>
                      )
                    })
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phoneNumber"
                  as={Form.Control}
                  value={values.phoneNumber}
                  onChange={handleLead}
                  placeholder="Enter Phone Number"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  as={Form.Control}
                  value={values.firstName}
                  onChange={handleLead}
                  placeholder="Enter First Name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Middle Name</Form.Label>
                <Form.Control
                  type="text"
                  name="middleName"
                  as={Form.Control}
                  value={values.middleName}
                  onChange={handleLead}
                  placeholder="Enter Middle Name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.lastName}
                  placeholder="Enter Last Name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="Gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  placeholder="Select Gender"
                  className="shadow-none focus:!border-theme-dark"
                  name="gender"
                  onChange={handleLead}
                  value={values.gender}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>{' '}
                  {/* Default placeholder option */}
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Transander">Transander </option>
                </Form.Select>
              </Form.Group>

            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label> Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  name="dateOfBirth"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.dateOfBirth}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <Form.Control
                  type="text"
                  name="country"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.country}
                  placeholder="Enter Country"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>State</Form.Label>
                <Form.Control
                  type="text"
                  name="state"
                  as={Form.Control}
                  value={values.state}
                  onChange={handleLead}
                  placeholder="Enter State"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.city}
                  placeholder="Enter City"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Area</Form.Label>
                <Form.Control
                  type="text"
                  name="area"
                  onChange={handleLead}
                  as={Form.Control}
                  value={values.area}
                  placeholder="Enter Area"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="leadReceived">
                <Form.Label>Lead Received On</Form.Label>
                <Form.Select
                  placeholder="Select Lead Received On"
                  className="shadow-none focus:!border-theme-dark"
                  name="leadReceived"
                  onChange={handleLead}
                  value={values.leadReceived}
                >
                  <option value="" disabled selected>
                    Select Lead Received On
                  </option>{' '}
                  {/* Default placeholder option */}
                  <option value="justdialApp">Justdial app</option>
                  <option value="phone">Phone</option>
                  <option value="social">Social</option>
                  <option value="email">Email</option>
                  <option value="whatsapp">Whatsapp</option>
                </Form.Select>
              </Form.Group>

            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="categoryIssues">
                <Form.Label>Consult </Form.Label>
                <div className='relative'>
                  <input name='problem' readOnly value={values.problem} placeholder={selectedProblem ? selectedProblem : 'Select Consult'} className='border w-full !border-theme-dark outline-none rounded py-[6px] px-[12px]' onClick={() => { setProblemData(!problemData); setSearchType('problem') }} />

                  <div className={`${problemData ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                    <input type='text' name='search' value={searchQuery} placeholder={`Search Consult`} onChange={searchData} className='w-full border p-2 rounded outline-none' />
                    {
                      createFile?.allProblem?.data?.Problem?.map((res) => {
                        return (
                          <p key={res._id} value={res.problem} onClick={() => selectProblem(res.problem)} className='text-gray-700 py-1 cursor-pointer'>{res.problem}</p>
                        )
                      })
                    }
                  </div>
                </div>
              </Form.Group>

            </div>
            {/* <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead Status</Form.Label>
                <Form.Select
                  placeholder="Select Lead Status"
                  className="shadow-none focus:!border-theme-dark"
                  name="leadStatus"
                  onChange={handleLead}
                  value={values.leadStatus}
                >
                  <option value="" disabled selected>
                    Select Lead Status
                  </option>
                  {console.log("setting?.getSetting?.leadStatuses", setting?.getSetting?.getSetting?.leadStatuses)}                  
                  {setting?.getSetting?.getSetting?.leadStatuses?.length > 0
                    ? setting?.getSetting?.getSetting?.leadStatuses?.map((status) => (
                      <option key={status._id} value={status.title}>
                        {status.title}
                      </option>
                    ))
                    : null}
                </Form.Select> */}
                {/* <ErrorMessage
                  name="leadStatus"
                  component="div"
                  className="text-danger"
                /> */}
              {/* </Form.Group>
            </div> */}
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead Status</Form.Label>
                <Form.Select
                  className="shadow-none focus:!border-theme-dark"
                  name="leadStatus"
                  onChange={handleLead}
                  value={values.leadStatus}
                  style={{
                    backgroundColor:
                      values.leadStatus?.trim()
                        ? getBackgroundColor(values.leadStatus.trim().toLowerCase())
                        : '',
                    color: values.leadStatus?.trim() ? 'white' : 'black'
                  }}
                >
                  <option value="" disabled style={{
                    backgroundColor:"lightgray",
                    color:"white"
                  }}>
                    Select Lead Status
                  </option>
                  {setting?.getSetting?.getSetting?.leadStatuses?.length > 0
                    ? setting?.getSetting?.getSetting?.leadStatuses?.map((status) => (
                      <option key={status._id} value={status.title}
                      style={{
                        backgroundColor:"white",
                        color:"black"
                      }}>
                        {status.title}
                      </option>
                    ))
                    : null}
                </Form.Select>
                {/* <ErrorMessage name="leadStatus" component="div" className="text-danger" /> */}
              </Form.Group>
            </div>


            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead From</Form.Label>
                <Form.Control
                  type="text"
                  name="leadFrom"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.leadFrom}
                  placeholder="Enter Lead"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="campaigen">
                <Form.Label>Campaigen</Form.Label>
                <Form.Select
                  className="shadow-none focus:!border-theme-dark"
                  name="cname"
                  onChange={handleCampaignChange}
                  value={values?.campaign[0]?.cname ? values?.campaign[0]?.cname : selectedCampaign}
                >
                  <option value="" disabled>
                    Select Campaigen
                  </option>{' '}
                  <option value="Walk-in">Walk-in</option>
                  <option value="Social">Social</option>
                  <option value="News">News</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group controlId="campaignDetail">
                <Form.Label>{selectedCampaign} Details</Form.Label>
                <Form.Control
                  type="text"
                  name='description'
                  placeholder={`Enter ${selectedCampaign} details`}
                  className="shadow-none"
                  onChange={handleCampaignChange}
                  value={values?.campaign[0]?.description ? values?.campaign[0]?.description : ''}
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="referance">
                <Form.Label>Referance</Form.Label>
                <Form.Select
                  className="shadow-none focus:!border-theme-dark"
                  name="reference"
                  onChange={handleReferenceChange}
                  value={selectedReference}
                >
                  <option value="" disabled>
                    Select Referance
                  </option>{' '}
                  <option value="Person">Person</option>
                  <option value="Doctor">Doctor</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group controlId="campaignDetail">
                <Form.Label>{selectedReference} Details</Form.Label>
                <div className='relative'>
                  <div className='border border-theme-dark rounded py-[6px] px-[12px]'
                    onClick={() => { setDoctorData(!doctorData); setSearchType(selectedReference) }}>
                    {selectedOption ? selectedOption : `Select ${selectedReference}`}
                  </div>
                  {
                    selectedReference === 'Doctor' && (
                      <div className={`${doctorData ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                        <input type='text' name='search' value={searchQuery} placeholder={`Search ${selectedReference}..`} onChange={searchData} className='w-full border p-2 rounded outline-none' />
                        {
                          createFile?.allDoctor?.data?.doctor?.map((res) => {
                            return (
                              <p key={res._id} value={res.name}
                                onClick={() => {
                                  handleOptionSelect(res.name);
                                  dispatch(allDoctorSearchDetail({ page: '', search: '' }))
                                  setSearchQuery('');
                                }}
                                className='text-gray-700 py-1 cursor-pointer'>{res.name}</p>
                            )
                          })
                        }
                      </div>
                    )
                  }
                  {
                    selectedReference === 'Person' && (
                      <div className={`${doctorData ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                        <input type='text' name="search"
                          value={searchQuery}
                          onChange={searchData} placeholder={`Search ${selectedReference}..`} className='w-full border p-2 rounded outline-none' />
                        {
                          createFile?.allPatient?.data?.PatientData?.map((res) => {
                            return (
                              <p key={res._id} value={res.firstName + " " + res.lastName}
                                onClick={() => {
                                  handleOptionSelect(res.firstName + " " + res.lastName);
                                  dispatch(patientSearchData({ page: '', search: '' }))
                                  setSearchQuery('');
                                }} className='text-gray-700 py-1 cursor-pointer'>{res.firstName + " " + res.lastName}</p>
                            )
                          })
                        }
                      </div>
                    )
                  }
                </div>
              </Form.Group>
            </div>

             <div className="col-md-6">
              <Form.Group className="mb-6">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  name="remark" 
                  as="textarea"
                  rows={5}
                  cols={10}
                  value={values.remark}
                  onChange={handleLead}
                  placeholder="Enter Remark"
                  className="form-control shadow-none
            focus:!border-theme-dark"
                />
              </Form.Group>
            </div>

            {/* <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Referral</Form.Label>
                <Form.Control
                  type="text"
                  name="remark"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.remark}
                  placeholder="Enter Referral"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div> */}

            <div className="border-t"></div>
            <h4 className="my-3">Call Time</h4>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Next Followup Date</Form.Label>
                <Form.Control
                  type="date"
                  name="nextFollowUpDate"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.nextFollowUpDate}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="time"
                  name="from"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.from}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="time"
                  name="to"
                  as={Form.Control}
                  value={values.to}
                  onChange={handleLead}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Nationality</Form.Label>
                <Form.Control
                  type="text"
                  name="nationality"
                  as={Form.Control}
                  value={values.nationality}
                  onChange={handleLead}
                  placeholder="Enter Nationality"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>
            <div className="col-md-3">
              <Form.Group controlId="campaignDetail">
                <Form.Label>Dctor Name</Form.Label>
                <div className='relative'>
                  <input name='doctorName' readOnly value={values.doctorName} placeholder={selectedDoctor ? selectedDoctor : 'Select Doctor'}
                    className='border w-full border-theme-dark outline-none rounded py-[6px] px-[12px]'
                    onClick={() => { setDoctorData1(!doctorData1); setSearchType('doctor') }} />

                  <div className={`${doctorData1 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                    <input type='text' name='search' value={searchQuery} placeholder={`Search Doctor`} onChange={searchData} className='w-full border p-2 rounded outline-none' />
                    {
                      createFile?.allDoctor?.data?.doctor?.map((res) => {
                        return (
                          <p key={res._id} value={res.name} onClick={() => selectDoctor(res.name)} className='text-gray-700 py-1 cursor-pointer'>{res.name}</p>
                        )
                      })
                    }
                  </div>
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <div className="">
                  <Form.Group className="mb-3">
                    <Form.Label>Counsellor assign</Form.Label>
                    <div className='relative'>
                      <input name='counselorAssign' readOnly value={values.counselorAssign} placeholder={selectedCounselor ? selectedCounselor : 'Select Counselor'} className='border w-full border-theme-dark  outline-none rounded py-[6px] px-[12px]' onClick={() => { setDoctorData2(!doctorData2); setSearchType('counselor') }} />

                      <div className={`${doctorData2 ? 'opacity-100 visible' : 'opacity-0 invisible'} absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}>
                        <input type='text' name='search' value={searchQuery} placeholder={`Search Counselors`} onChange={searchData} className='w-full border p-2 rounded outline-none' />
                        {
                          createFile?.allCounselor?.data?.CounselorsData?.map((res) => {
                            return (
                              <p key={res._id} value={res.name} onClick={() => selectCounselor(res.name)} className='text-gray-700 py-1 cursor-pointer'>{res.name}</p>
                            )
                          })
                        }
                      </div>
                    </div>

                  </Form.Group>
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Occupation</Form.Label>
                <Form.Control
                  type="text"
                  name="occupation"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.occupation}
                  placeholder="Enter Occupation"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>

            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  as={Form.Control}
                  value={values.email}
                  onChange={handleLead}
                  placeholder="Enter Email"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.address}
                  placeholder="Enter Address"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Blood Group</Form.Label>
                <Form.Control
                  type="text"
                  name="bloodGroup"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.bloodGroup}
                  placeholder="Enter Blood Group"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  type="text"
                  name="pincode"
                  as={Form.Control}
                  value={values.pincode}
                  onChange={handleLead}
                  placeholder="Enter Pincode"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead FollowUp Remark</Form.Label>
                <Form.Control
                  type="text"
                  name="leadFollowUpRemark"
                  as={Form.Control}
                  onChange={handleLead}
                  value={values.leadFollowUpRemark}
                  placeholder="Select Lead FollowUp Remark"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Photo</Form.Label>
                <Form.Control
                  type="file"
                  name="photo"
                  as={Form.Control}
                  onChange={handleFileChange}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            {values.photo && (
              <>
                <div className="mt-2">
                  <strong>Chosen file:</strong>
                  {/* {typeof values.photo === 'string' ? values.photo : values.photo.name} */}
                </div>
                {typeof values.photo === 'string' ? (
                  <img src={values.photo} alt="Uploaded" className='!w-[100px] mb-3' />
                ) : null}
              </>
            )}
          </div>

          <div className="border-t"></div>
          <h5 className="my-3">Call Log History</h5>

          <TableContainer>
            <Table variant="striped" colorScheme="blackAlpha">
              <Thead>
                <Tr>
                  <Th>Date</Th>
                  <Th>Time</Th>
                  <Th>Branch</Th>
                  <Th>Phone Number</Th>
                  <Th>First Name</Th>
                  <Th>Middle Name</Th>
                  <Th>Last Name</Th>
                  <Th>Gender</Th>
                  <Th>Date of Birth</Th>
                  <Th>Country</Th>
                  <Th>State</Th>
                  <Th>City</Th>
                  <Th>Area</Th>
                  <Th>Lead Received On</Th>
                  <Th>Consult</Th>
                  <Th>Lead Status</Th>
                  <Th>Campaign</Th>
                  <Th>Campaign Details</Th>
                  <Th>Reference</Th>
                  <Th>Remark</Th>
                  <Th>Next Followup Date</Th>
                  <Th>From</Th>
                  <Th>To</Th>
                  <Th>Nationality</Th>
                  <Th>Doctor Name</Th>
                  <Th>Counselor Assign</Th>
                  <Th>Occupation</Th>
                  <Th>Email</Th>
                  <Th>Address</Th>
                  <Th>Blood Group</Th>
                  <Th>Pincode</Th>
                  <Th>Lead FollowUp Remark</Th>
                  <Th>Photo</Th>
                </Tr>
              </Thead>
              <Tbody>
                {
                  displayedRecords.length > 0 ? (
                    displayedRecords.map((res) => (
                      <Tr key={res._id}>
                        <Td>{formatDate(res?.timestamp)}</Td>
                        <Td>{new Date(res?.timestamp).toLocaleTimeString()}</Td>
                        <Td>{res?.updatedRecord?.branch}</Td>
                        <Td>{res?.updatedRecord?.phoneNumber}</Td>
                        <Td>{res?.updatedRecord?.firstName}</Td>
                        <Td>{res?.updatedRecord?.middleName}</Td>
                        <Td>{res?.updatedRecord?.lastName}</Td>
                        <Td>{res?.updatedRecord?.gender}</Td>
                        <Td>{formatDate(res?.updatedRecord?.dateOfBirth)}</Td>
                        <Td>{res?.updatedRecord?.country}</Td>
                        <Td>{res?.updatedRecord?.state}</Td>
                        <Td>{res?.updatedRecord?.city}</Td>
                        <Td>{res?.updatedRecord?.area}</Td>
                        <Td>{res?.updatedRecord?.leadReceived}</Td>
                        <Td>{res?.updatedRecord?.problem}</Td>
                        <Td>{res?.updatedRecord?.leadStatus}</Td>
                        <Td>{res?.updatedRecord?.campaign?.length > 0 ? res.updatedRecord.campaign[0].cname : ''}</Td>
                        <Td>{res?.updatedRecord?.campaign?.length > 0 ? res?.updatedRecord?.campaign[0]?.description : ''}</Td>
                        <Td>
                          {Array.isArray(res?.updatedRecord?.reference) && res?.updatedRecord?.reference.length > 0
                            ? res?.updatedRecord?.reference[0]?.doctorDetail || res?.updatedRecord?.reference[0]?.personDetail || ''
                            : 'No Reference Available'}
                        </Td>
                        <Td>{res?.updatedRecord?.remark}</Td>
                        <Td>{formatDate(res?.updatedRecord?.nextFollowUpDate)}</Td>
                        <Td>{formatTime(res?.updatedRecord?.from)}</Td>
                        <Td>{formatTime(res?.updatedRecord?.to)}</Td>
                        <Td>{res?.updatedRecord?.nationality}</Td>
                        <Td>{res?.updatedRecord?.doctorName}</Td>
                        <Td>{res?.updatedRecord?.counselorAssign}</Td>
                        <Td>{res?.updatedRecord?.occupation}</Td>
                        <Td>{res?.updatedRecord?.email}</Td>
                        <Td>{res?.updatedRecord?.address}</Td>
                        <Td>{res?.updatedRecord?.bloodGroup}</Td>
                        <Td>{res?.updatedRecord?.pincode}</Td>
                        <Td>{res?.updatedRecord?.leadFollowUpRemark}</Td>
                        <Td><img src={res?.updatedRecord?.photo || userPhoto} alt="photo" width={'70px'} /></Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan="31">No call logs available</Td>
                    </Tr>
                  )
                }
              </Tbody>
            </Table>
          </TableContainer>

          {/* Show "Show More" or "Show Less" based on the state */}
          {updateHistory.length > 3 && (
            <div className='text-end cursor-pointer underline mt-2' onClick={toggleShow} mt={4}>
              {showAll ? 'Show Less' : 'Show More'}
            </div>
          )}

        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={updateToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Close
          </Button>
          <Button onClick={handleUpdate} className="!bg-theme-dark border-0 px-4">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FileUpdate;